// extracted by mini-css-extract-plugin
module.exports = {"container":"AppStoreButton_container__2lHr6","appStoreButtonLink":"AppStoreButton_appStoreButtonLink__1gWsB","appStoreButton":"AppStoreButton_appStoreButton__j1JIt"};